// extracted by mini-css-extract-plugin
export default {"spiner":"Spiner_spiner__Y3Bg-"};